module.exports = __webpack_public_path__ + "img/carousel-premium-2.8b9e45ff.jpg";